import { createSlice } from "@reduxjs/toolkit";
import { boardViewForAllocation } from "./TransferOrderSliceV2";
import { sortAllView } from "../utils";

const transactionReasonDefaultColumns = ["REASON", "CODE", "IMPACT", "CREATED BY", "CREATE DATE"];

const initialState = {
  transactions: { count: 0, results: [] },
  transactionsParams: { limit: 10, offset: 0 },

  transactionReasons: { count: 0, results: [] },
  transactionReasonsParams: { limit: 10, offset: 0 },
  transactionReasonsSelection: null,

  reportForPurchase: null,
  reportConfigForPurchase: null,
  pivotConfig: null,
  listOfPivotConfig: null,
  status: null,
  warehouse: null,
  supplier: null,
  products: null,
  reportInExcel: null,
  users: null,
  automateList: [],
  standardReport: { id: null, results: [] },
  isShowStandardReport: false,
  listOfStdConfig: null,

  transactionReasonLayout: {
    completeListOfViews: [],
    listView: {
      allItemsName: transactionReasonDefaultColumns,
      allViews: {
        "Default View": transactionReasonDefaultColumns,
      },
      nameOfViews: [],
    },
    ...boardViewForAllocation,
  },
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    setTransactionReasonLayoutAllViews: (state, action) => {
      const data = action.payload;
      const views = sortAllView(data);
      state.transactionReasonLayout = {
        ...state.transactionReasonLayout,
        listView: {
          ...state.transactionReasonLayout.listView,
          nameOfViews: views.list.nameOfList,
          allViews: { ...state.transactionReasonLayout.listView.allViews, ...views.list.allViews },
        },
        completeListOfViews: action.payload,
      };
    },
    setTransactions: (state, action) => {
      state.transactions = action.payload;
    },
    setTransactionReasons: (state, action) => {
      state.transactionReasons = action.payload;
    },
    setTransactionReasonsSelection: (state, action) => {
      state.transactionReasonsSelection = action.payload;
    },
    resetTransactions: state => {
      state.transactions = initialState.transactions;
    },
    resetTransactionsParams: state => {
      state.transactionsParams = initialState.transactionsParams;
    },
    setTransactionsParams: (state, action) => {
      state.transactionsParams = { ...state.transactionsParams, ...action.payload };
    },
    setPurchaseReport: (state, action) => {
      state.reportForPurchase = action.payload;
    },
    setConfigReportForPurchase: (state, action) => {
      state.reportConfigForPurchase = action.payload;
    },
    setPivotConfig: (state, action) => {
      state.pivotConfig = action.payload;
    },
    setListOfPivotConfig: (state, action) => {
      state.listOfPivotConfig = action.payload;
    },
    setOrderStatus: (state, action) => {
      state.status = action.payload;
    },
    setOrderSupplier: (state, action) => {
      state.supplier = action.payload;
    },
    setOrderWarehouse: (state, action) => {
      state.warehouse = action.payload;
    },
    setListOfProducts: (state, action) => {
      state.products = action.payload;
    },
    setReportExcelData: (state, action) => {
      state.reportInExcel = action.payload;
    },
    setListOfUsers: (state, action) => {
      state.users = action.payload;
    },
    setListOfAutomate: (state, action) => {
      state.automateList = action.payload;
    },
    setDataOfStandardReport: (state, action) => {
      const { report_data, std_report_config_id } = action.payload;
      let id = null;
      let results = [];
      if (std_report_config_id) {
        id = std_report_config_id;
        results = report_data;
      } else {
        results = action.payload;
      }
      state.standardReport = { results, id };
    },
    setDataOfStandardReportFromGet: (state, action) => {
      const { id, data } = action.payload;
      state.standardReport = { results: data, id };
    },
    setStandardReportVisibility: (state, action) => {
      state.isShowStandardReport = action.payload;
    },
    setListOfStdConfig: (state, action) => {
      state.listOfStdConfig = action.payload;
    },
    setVisibilityOfStandardReport: (state, action) => {
      const id = action.payload;
      const stdReports = state.listOfStdConfig?.map(report =>
        report.id === id ? { ...report, is_active: !report.is_active } : report,
      );
      state.listOfStdConfig = stdReports;
    },
    setVisibilityOfPivotConfigReport: (state, action) => {
      const id = action.payload;
      const pivotReports = state.listOfPivotConfig?.map(report =>
        report.id === id ? { ...report, is_active: !report.is_active } : report,
      );
      state.listOfPivotConfig = pivotReports;
    },

    updateTransactionReasonParams: (state, action) => {
      state.transactionReasonsParams = { ...state.transactionReasonsParams, ...action.payload };
    },
  },
});

export const {
  setTransactionReasonLayoutAllViews,
  setTransactions,
  setTransactionReasons,
  setTransactionReasonsSelection,
  resetTransactions,
  resetTransactionsParams,
  setTransactionsParams,
  setPurchaseReport,
  setConfigReportForPurchase,
  setPivotConfig,
  setListOfPivotConfig,
  setPurchaseOrderStatus,
  setOrderStatus,
  setOrderSupplier,
  setOrderWarehouse,
  setListOfProducts,
  setReportExcelData,
  setListOfUsers,
  setListOfAutomate,
  setDataOfStandardReport,
  setDataOfStandardReportFromGet,
  setStandardReportVisibility,
  setListOfStdConfig,
  setVisibilityOfStandardReport,
  setVisibilityOfPivotConfigReport,
  updateTransactionReasonParams,
} = reportSlice.actions;
export default reportSlice.reducer;
